import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';

const leadingZero = (value) => {
  if (value < 10) {
    return `0${value.toString()}`;
  }
  return value.toString();
};

const parseDate = (targetDate) => {
  const dd = targetDate.getDate();
  const mm = targetDate.getMonth() + 1;
  const yyyy = targetDate.getFullYear();
  return `${yyyy}-${leadingZero(mm)}-${leadingZero(dd)}`;
};

function* getCupDayCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    phase: action.phase,
    subPhase: action.subPhase,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
    yield put({ type: types.GET_CUP_DAY_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CUP_DAY_CALENDAR_ERROR, error });
  }
}

function* getVolleyDayCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    phase: action.phase,
    subPhase: action.subPhase,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
    yield put({ type: types.GET_VOLLEY_DAY_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_VOLLEY_DAY_CALENDAR_ERROR, error });
  }
}

function* getCupTabbar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    if (action.phase) {
      urlParams.phase = action.phase;
    }
    if (action.subPhase) {
      urlParams.subPhase = action.subPhase;
    }
    yield put({ type: types.GET_CUP_TABBAR_SUCCESS, data, urlParams });
    // if (action.phase &&
    //   (String(action.sportId) !== '1' || (String(action.sportId) === '1' && String(action.competitionId) !== '105'))
    // ) {
    //   yield getCupDayCalendar(action);
    // }
  } catch (error) {
    yield put({ type: types.GET_CUP_TABBAR_ERROR, error });
  }
}

function* getVolleyTabbar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    if (action.phase) {
      urlParams.phase = action.phase;
    }
    if (action.subPhase) {
      urlParams.subPhase = action.subPhase;
    }
    urlParams.isCup = action.isCup;
    yield put({ type: types.GET_VOLLEY_TABBAR_SUCCESS, data, urlParams });
  } catch (error) {
    yield put({ type: types.GET_VOLLEY_TABBAR_ERROR, error });
  }
}

function* getRugbyTabbar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    if (action.phase) {
      urlParams.phase = action.phase;
    }
    if (action.subPhase) {
      urlParams.subPhase = action.subPhase;
    }
    yield put({ type: types.GET_RUGBY_TABBAR_SUCCESS, data, urlParams });
  } catch (error) {
    yield put({ type: types.GET_RUGBY_TABBAR_ERROR, error });
  }
}

function* getBasketTabbar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    if (action.phase) {
      urlParams.phase = action.phase;
    }
    if (action.subPhase) {
      urlParams.subPhase = action.subPhase;
    }
    yield put({ type: types.GET_BASKET_TABBAR_SUCCESS, data, urlParams });
  } catch (error) {
    yield put({ type: types.GET_BASKET_TABBAR_ERROR, error });
  }
}

function* getCupCalendar(action) {
  const urlParams = {
    sportId: action.urlParams.sportId,
    competitionId: action.urlParams.competitionId,
    seasonId: action.urlParams.seasonId,
  };
  urlParams.phase = action.urlParams.phase ? action.urlParams.phase : action.data.lastPhase.label;
  if (action.urlParams.subPhase) {
    urlParams.subPhase = action.urlParams.subPhase;
  } else if (action.data.lastSubPhase) {
    urlParams.subPhase = action.data.lastSubPhase;
  } else if (action.data.nextSubPhase) {
    urlParams.subPhase = action.data.nextSubPhase;
  }
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
    yield put({ type: types.GET_CUP_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CUP_CALENDAR_ERROR, error });
  }
}

function* getVolleyCalendar(action) {
  const { urlParams } = action;
  if (typeof urlParams.phase === 'undefined' && typeof urlParams.subPhase === 'undefined') {
    urlParams.phase = action.data.lastPhase.label;
    urlParams.subPhase = action.data.lastSubPhase;
  }
  const isNumber = !Number.isNaN(Number(urlParams.phase));
  try {
    if (urlParams.phase === 'groups') {
      if (urlParams.isCup) {
        yield getVolleyDayCalendar(urlParams);
      } else {
        yield put({
          type: types.GET_CUP_DAY_CALENDAR_REQUEST,
          sportId: action.urlParams.sportId,
          competitionId: action.urlParams.competitionId,
          phase: urlParams.phase,
          subPhase: urlParams.subPhase,
          seasonId: action.urlParams.seasonId,
        });
      }
    } else if (urlParams.phase === 'regular-season') {
      yield put({
        type: types.GET_CALENDAR_REQUEST,
        sportId: action.urlParams.sportId,
        competitionId: action.urlParams.competitionId,
        seasonId: action.urlParams.seasonId,
      });
    } else if (isNumber) {
      yield put({
        type: types.GET_DAY_CALENDAR_REQUEST,
        sportId: action.urlParams.sportId,
        competitionId: action.urlParams.competitionId,
        day: Number(action.urlParams.phase),
        seasonId: action.urlParams.seasonId,
      });
    } else {
      const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
      yield put({ type: types.GET_VOLLEY_CALENDAR_SUCCESS, data });
    }
  } catch (error) {
    yield put({ type: types.GET_VOLLEY_CALENDAR_ERROR, error });
  }
}

function* getRugbyCalendar(action) {
  const { urlParams } = action;
  if (typeof urlParams.phase === 'undefined' && typeof urlParams.subPhase === 'undefined') {
    urlParams.phase = action.data.lastPhase.label;
    urlParams.subPhase = action.data.lastSubPhase;
  }
  if (urlParams.phase && urlParams.phase === 'regularSeason') {
    urlParams.subPhase = '';
  }
  const isNumber = !Number.isNaN(Number(urlParams.phase));
  try {
    if (isNumber) {
      yield put({
        type: types.GET_QUERY_PARAM_CALENDAR_REQUEST,
        sportId: action.urlParams.sportId,
        competitionId: action.urlParams.competitionId,
        day: Number(action.urlParams.phase),
        seasonId: action.urlParams.seasonId,
      });
    } else {
      const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
      //Fix nel caso la giornata sia maggiore del numero max di giornate
      if (data.currentDay && data.numberDays && Number(data.currentDay) > Number(data.numberDays)) {
        urlParams.phase = String(data.numberDays);
        yield put({ type: types.GET_RUGBY_TABBAR_SUCCESS, data: action.data, urlParams });
      } else {
        yield put({ type: types.GET_RUGBY_CALENDAR_SUCCESS, data });
      }
    }
  } catch (error) {
    yield put({ type: types.GET_RUGBY_CALENDAR_ERROR, error });
  }
}

function* getNbaCalendar(action) {
  const urlParams = {
    day: new Date(action.date).toISOString().split('T')[0],
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  const currentDay = action.date;
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCalendar', urlParams);
    yield put({ type: types.GET_NBA_CALENDAR_SUCCESS, data, currentDay });
  } catch (error) {
    yield put({ type: types.GET_NBA_CALENDAR_ERROR, error });
  }
}

function* getBasketCalendar(action) {
  const { urlParams } = action;
  let currentDay = null;
  if (typeof urlParams.phase === 'undefined') {
    urlParams.phase = action.data.lastPhase.label;
    urlParams.subPhase = action.data.lastSubPhase;
  }
  if (urlParams.phase !== 'preSeason' && urlParams.phase !== 'regularSeason' && urlParams.phase !== 'playoffs' && urlParams.phase !== 'extraPlayoffs' && urlParams.phase !== 'groups' && urlParams.phase !== 'NBACup') {
    //Considero come data di calendario
    urlParams.day = urlParams.phase;
    if (String(urlParams.competitionId) === '3') {
      const targetDate = moment(urlParams.phase, 'YYYY-MM-DD').set({ hour: 0, minute: 0, second: 1 });
      currentDay = targetDate;
      const phases = Object.keys(action.data.phases);
      phases.forEach((phaseName, index) => {
        const phase = action.data.phases[phaseName];
        const startDate = moment(phase.startDate);
        const endDate = moment(phase.endDate);
        if (
          (targetDate.isBetween(startDate, endDate, null, '[]')) ||
          (index === 0 && targetDate.isBefore(startDate)) ||
          ((index + 1) === phases.length && targetDate.isAfter(endDate))
        ) {
          urlParams.phase = phaseName;
        }
      });
    } else {
      currentDay = Number(urlParams.phase);
    }
  }
  if (urlParams.phase !== 'playoffs' && urlParams.phase !== 'NBACup' && !urlParams.day && String(urlParams.competitionId) === '3') {
    urlParams.subPhase = null;
    const now = new Date();
    currentDay = now;
    let day = parseDate(now);
    const currentPhase = action.data.phases[urlParams.phase] || null;
    if (currentPhase && currentPhase.startDate && currentPhase.endDate) {
      const startDate = new Date(currentPhase.startDate);
      const endDate = new Date(currentPhase.endDate);
      if (now < startDate) {
        day = parseDate(startDate);
        currentDay = startDate;
      }
      if (now > endDate) {
        endDate.setDate(endDate.getDate() - 6);
        day = parseDate(endDate);
        currentDay = endDate;
      }
    }
    urlParams.day = day;
  }
  if (urlParams.day === urlParams.phase) {
    urlParams.phase = 'regularSeason';
  }
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getBasketCalendar', urlParams);
    if (String(urlParams.competitionId) === '3') {
      yield put({
        type: types.GET_NBA_CALENDAR_SUCCESS, data, currentDay, phase: urlParams.phase, subPhase: urlParams.subPhase,
      });
    } else {
      if (!currentDay) {
        // eslint-disable-next-line prefer-destructuring
        currentDay = data.currentDay;
      }
      yield put({
        type: types.GET_BASKET_CALENDAR_SUCCESS, data, currentDay, phase: urlParams.phase, subPhase: urlParams.subPhase,
      });
    }
  } catch (error) {
    yield put({ type: types.GET_VOLLEY_CALENDAR_ERROR, error });
  }
}

function* getDayCalendar(action) {
  const urlParams = {
    day: action.day,
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  const currentDay = action.day;
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCalendar', urlParams);
    yield put({ type: types.GET_DAY_CALENDAR_SUCCESS, data, currentDay });
  } catch (error) {
    yield put({ type: types.GET_DAY_CALENDAR_ERROR, error });
  }
}

function* getQueryParamCalendar(action) {
  const urlParams = {
    day: action.day,
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  const currentDay = action.day;
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCalendar', urlParams);
    yield put({ type: types.GET_QUERY_PARAM_CALENDAR_SUCCESS, data, currentDay });
  } catch (error) {
    yield put({ type: types.GET_QUERY_PARAM_CALENDAR_ERROR, error });
  }
}

function* getCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CALENDAR_ERROR, error });
  }
}

function* getCycleCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_CYCLE_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CYCLE_CALENDAR_ERROR, error });
  }
}

function* getMotorSportCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_MOTORSPORT_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_MOTORSPORT_CALENDAR_ERROR, error });
  }
}

function* getTennisCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    order: action.order,
    seasonId: action.seasonId,
    phase: action.phase,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendarTennis', urlParams);
    data.phase = action.phase || false;
    yield put({ type: types.GET_TENNIS_CALENDAR_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_TENNIS_CALENDAR_ERROR, error });
  }
}

function* watchGetTennisCalendar() {
  yield takeLatest(types.GET_TENNIS_CALENDAR_REQUEST, getTennisCalendar);
}

function* watchGetCycleCalendar() {
  yield takeLatest(types.GET_CYCLE_CALENDAR_REQUEST, getCycleCalendar);
}

function* watchGetMotorSportCalendar() {
  yield takeLatest(types.GET_MOTORSPORT_CALENDAR_REQUEST, getMotorSportCalendar);
}

function* watchGetDayCalendar() {
  yield takeLatest(types.GET_DAY_CALENDAR_REQUEST, getDayCalendar);
}

function* watchGetCupDayCalendar() {
  yield takeLatest(types.GET_CUP_DAY_CALENDAR_REQUEST, getCupDayCalendar);
}

function* watchGetVolleyDayCalendar() {
  yield takeLatest(types.GET_VOLLEY_DAY_CALENDAR_REQUEST, getVolleyDayCalendar);
}

function* watchGetCalendar() {
  yield takeLatest(types.GET_CALENDAR_REQUEST, getCalendar);
}

function* watchGetCupTabbar() {
  yield takeLatest(types.GET_CUP_TABBAR_REQUEST, getCupTabbar);
}

function* watchGetCupCalendar() {
  yield takeLatest(types.GET_CUP_TABBAR_SUCCESS, getCupCalendar);
}

function* watchGetVolleyTabbar() {
  yield takeLatest(types.GET_VOLLEY_TABBAR_REQUEST, getVolleyTabbar);
}

function* watchGetRugbyTabbar() {
  yield takeLatest(types.GET_RUGBY_TABBAR_REQUEST, getRugbyTabbar);
}

function* watchGetBasketTabbar() {
  yield takeLatest(types.GET_BASKET_TABBAR_REQUEST, getBasketTabbar);
}

function* watchGetVolleyCalendar() {
  yield takeLatest(types.GET_VOLLEY_TABBAR_SUCCESS, getVolleyCalendar);
}

function* watchGetRugbyCalendar() {
  yield takeLatest(types.GET_RUGBY_TABBAR_SUCCESS, getRugbyCalendar);
}

function* watchGetBasketCalendar() {
  yield takeLatest(types.GET_BASKET_TABBAR_SUCCESS, getBasketCalendar);
}

function* watchGetQueryParamCalendar() {
  yield takeLatest(types.GET_QUERY_PARAM_CALENDAR_REQUEST, getQueryParamCalendar);
}

function* watchGetNbaCalendar() {
  yield takeLatest(types.GET_NBA_CALENDAR_REQUEST, getNbaCalendar);
}

export default [
  watchGetQueryParamCalendar,
  watchGetDayCalendar,
  watchGetCalendar,
  watchGetCupTabbar,
  watchGetCupCalendar,
  watchGetCupDayCalendar,
  watchGetMotorSportCalendar,
  watchGetTennisCalendar,
  watchGetCycleCalendar,
  watchGetVolleyTabbar,
  watchGetVolleyCalendar,
  watchGetNbaCalendar,
  watchGetVolleyDayCalendar,
  watchGetBasketTabbar,
  watchGetBasketCalendar,
  watchGetRugbyTabbar,
  watchGetRugbyCalendar,
];




// WEBPACK FOOTER //
// ./src/sagas/calendar.js